import React from "react";
import { translate } from "../../addons/Translate";

const Footer = (props) => {
	const { restaurant } = window;

	if(restaurant.settings.gdpr === null)
		return null;

	return (
		<div className="page-footer">
			<div className="footer">
				<div className="ui container">
					<ul>
						<li><a href={restaurant.settings.gdpr} target="_blank">{translate("xxltable.footer.gdpr")}</a></li>
					</ul>
				</div>
			</div>
		</div>
	);
}

export default Footer;


// WEBPACK FOOTER //
// ./src/components/ui/Footer.js